// extracted by mini-css-extract-plugin
export default {"skuDetailv2_m":"Main_skuDetailv2_m__6QU72","skuDetailv2M":"Main_skuDetailv2_m__6QU72"};